import { classicRegisterLineSidtance, dy, gateFontSize } from './constants';
import Gate from './figures/Gate';
import Measure from './figures/Measure';

import useFigure from './useFigure';

const CanvasContent = ({
  gates,
  registers,
  width,
  height,
  classicRegisters,
}) => {
  const Line = useFigure('line');
  const Text = useFigure('text');

  const CanvasFill = useFigure('canvasFill');
  CanvasFill({
    fill: '#060E1F',
    width,
    height,
  });
  registers.forEach((register, i) => {
    Line(register);
    Text({
      text: `q[${i}]`,
      x: register.x1 - 10,
      y: register.y1,
      fill: '#A9B0BC',
      textBaseline: 'middle',
      textAlign: 'right',
      font: `${gateFontSize}px Satoshi monospace`,
    });
  });

  classicRegisters.forEach((register) => {
    Line(register);
  });
  Text({
    text: `c${registers.length}`,
    x: registers[registers.length - 1].x1 - 10,
    y: registers[registers.length - 1].y1 + dy + classicRegisterLineSidtance / 2,
    fill: '#A9B0BC',
    textBaseline: 'middle',
    textAlign: 'right',
    font: `${gateFontSize}px Satoshi`,
  });

  gates.forEach((gate) => {
    if (gate.name === 'MeasurementGate') {
      Measure(gate);
    } else {
      Gate(gate);
    }
  });
};

export default CanvasContent;
